module.exports = __webpack_public_path__ + "img/green-pita-00.b8a6eecc.png";